module.exports = __webpack_public_path__ + "img/fb14dad.jpg";